export const deskQrcodeOrigin: string | undefined = 'https://i.whliupangzi.cn/scan'   // 餐台二维码链接
export const documentUrl: string = 'https://i.whliupangzi.cn/doc'   // 文档地址
export const processScanUrl: string = 'https://i.whliupangzi.cn/redirect'  // 小程序扫码地址
export const srcUrl: string = 'https://src.whliupangzi.cn'  // 资源服务链接